// Error components must be Client Components
'use client';

import '../tailwind-stadswonen.css';

import { GlobalError, SITES } from '@woonstad/ui-public-sites';

export default function GlobalErrorPage(props: Readonly<Parameters<typeof GlobalError>[0]>) {
  return (
    <GlobalError
      {...props}
      site={SITES.Stadswonen}
    />
  );
}
